export const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:5000";

export const MODEL_API_URL =
  process.env.REACT_APP_MODEL_API_URL ?? "http://localhost:5001";
